import { useCallback, useEffect } from 'react';
import { capabilities } from 'navigation-components/capabilities';
import { DEMO_EXIT_CONFIRMATION_COMPONENT, demoExitConfirmationComponentDef } from 'navigation-components/config';
import { useCapability, useComponentProps, useToggleComponent } from 'navigation-components/platform/hooks';
export const useSubscribeToShowDemoExitConfirmation = () => {
  const {
    subscribe: subscribeToShowDemoExitConfirmation
  } = useCapability(capabilities.SHOW_DEMO_EXIT_CONFIRMATION_CAP.getName());
  const demoExitConfirmationComponentProps = useComponentProps(demoExitConfirmationComponentDef);
  const {
    toggle: toggleDemoExitConfirmationComponent
  } = useToggleComponent(DEMO_EXIT_CONFIRMATION_COMPONENT);
  const handleShowConfirmation = useCallback(({
    appSource,
    url
  }) => {
    demoExitConfirmationComponentProps({
      url,
      appSource
    });
    toggleDemoExitConfirmationComponent();
  }, [demoExitConfirmationComponentProps, toggleDemoExitConfirmationComponent]);
  useEffect(() => {
    return subscribeToShowDemoExitConfirmation(handleShowConfirmation);
  }, [handleShowConfirmation, subscribeToShowDemoExitConfirmation]);
};